<div class="d-block d-lg-flex align-items-center justify-content-end">
  <label class="fw-bold small me-2" id="period">Period</label>
  <input [(ngModel)]="dateFromSelector"
         (blur)="onCustomDateChange()"
         [class.is-invalid]="dateRangeInvalid"
         class="form-control form-control-sm mb-2 mb-lg-0 me-0 me-lg-1"
         id="start-date" placeholder="Start Date" type="date">
  <input [(ngModel)]="dateToSelector"
         (blur)="onCustomDateChange()"
         [class.is-invalid]="dateRangeInvalid"
         class="form-control form-control-sm mb-2 mb-lg-0 me-0 me-lg-2"
         id="end-date" placeholder="End Date" type="date">
  <div *ngIf="dateRangeInvalid" class="invalid-feedback d-block">
    {{ 'dateRange.invalid' | translate }}
  </div>

  <select [(ngModel)]="dateSelector" (change)="onDateChange()" id="period-shortcut" class="form-select form-select-sm me-0 me-lg-2">
    <option value="today">Today</option>
    <option value="yesterday">Yesterday</option>
    <option value="this-week">This Week</option>
    <option value="last-week">Last Week</option>
    <option value="this-month">This Month</option>
    <option value="last-month">Last Month</option>
    <option value="this-year">This Year</option>
    <option value="last-year">Last Year</option>
    <option value="custom">Custom</option>
  </select>

  <ng-container *ngIf="showTimezone">
    <select id="gmt" class="form-select form-select-sm me-0 me-lg-2" [(ngModel)]="timezone" (change)="onDateChange()">
      <option *ngFor="let timezone of getTimezones()"
              [value]="timezone">{{ getTimezoneOffsetLabel(timezone) + (shortTimezone ? '' : 'timezone.' + timezone  | translate) }}
      </option>
    </select>
  </ng-container>
</div>
